import * as SliderTheme from './components/Slider.css';
export default { SliderTheme };
